import { FC } from 'react'

import { INavigationProps } from './models/navigationProps'
import { NavigationItem } from './NavigationItem'

import styles from './Navigation.module.scss'

export const Navigation: FC<INavigationProps> = ({
  currentStep,
  steps,
  isDisabled,
  onStepChange,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.breadcrumb}>
        {steps.map((step) => {
          return (
            <NavigationItem
              key={step.order}
              isActive={step.order === currentStep}
              title={step.title}
              onStepChange={onStepChange(step.order)}
              isDisabled={isDisabled}
            />
          )
        })}
      </div>
    </div>
  )
}
